var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"d-flex flex-row text-primary pl-2 pr-2 pb-4"},[_c('i',{staticClass:"fas fa-quote-left pr-2"}),_vm._v(" "),_c('label',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('i',{staticClass:"fas fa-quote-right pl-2 align-self-end"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }